// @flow

import * as React from 'react';

import { useTrackingProps } from '@gandi/billing';
import { withLogger } from 'gandi.redux-logger';

type Props = {|
  children: React.Node,
|};

function Root({ children }: Props): React.Node {
  useTrackingProps();
  return children;
}

export default (withLogger('support/containers/Root')(
  // $FlowFixMe[prop-missing]
  // $FlowFixMe[incompatible-exact]
  Root
): React.ComponentType<Props>);
